import axios from 'axios';

const API_BASE_URL = 'https://servermain.sisrevolution.com/api';

// Simple vendor order service matching original VendorPortal
export const vendorOrderService = {
  // Submit purchase order (main functionality)
  submitOrder: async (orderData) => {
    try {
      const response = await axios.post(`${API_BASE_URL}/vendor/submit-order`, orderData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default vendorOrderService; 